import { useUpdateLayer } from 'hooks/queries/layers/useUpdateLayer'
import { useRevokeAllLayerAccessGrants } from 'hooks/queries/layerAccessGrants/useRevokeAllLayerAccessGrants'
import { LayerSharingMode } from 'types'

interface Props {
  layerId: string
  articleId: string
}

export const useUpdateLayerSharingMode = ({ layerId, articleId }: Props) => {
  const { mutateAsync: updateLayerAsync, isLoading: isUpdating } = useUpdateLayer(articleId, layerId)
  const { mutateAsync: revokeAllAccessGrants, isLoading: isRevoking } = useRevokeAllLayerAccessGrants({
    articleKey: articleId,
    layerId,
  })

  const makePublic = () => {
    return updateLayerAsync({ public: true, sharing_mode: LayerSharingMode.Public })
  }

  const makePrivate = async () => {
    if (isUpdating || isRevoking) {
      return
    }
    return Promise.all([
      updateLayerAsync({ public: false, sharing_mode: LayerSharingMode.Private }),
      revokeAllAccessGrants(),
    ])
  }

  const makeShared = () => {
    if (isUpdating || isRevoking) {
      return
    }
    return updateLayerAsync({ public: false, sharing_mode: LayerSharingMode.Shared })
  }

  return { makePrivate, makePublic, makeShared }
}
